<template>
    <div class="search-page">
        <div class="search-page__header">
            <span class="label">搜索结果</span>
            <el-input v-model="searchValue" placeholder="请输入需要搜索的关键信息">
                <template #prefix>
                    <el-icon color="#808080" size="24"><Search /></el-icon>
                </template>
                <template #append>
                    <div class="button-text" @click="handleSearch">搜索</div>
                </template>
            </el-input>
        </div>
        <div class="search-page__main">
            <div class="page-filter">
                <span class="page-filter__tip">类别</span>
                <el-radio-group class="page-filter__radio" v-model="searchFilter" @change="changeFilterValue">
                    <el-radio :value="radio.value" v-for="(radio, index) in radioList" :key="index" :label="radio.label"></el-radio>
                </el-radio-group>
            </div>
            <div class="page-content">
                <div class="page-content__number"><span>{{ searchResultList.length }}</span>条结果</div>
                <div class="page-content__view">
                    <div class="item" v-for="(result, index) in searchResultList" :key="index" @click="handleClick(result)">
                        <el-image class="item-image" :src="filterImage(result.imagePath)"></el-image>
                        <div class="item-info">
                            <span class="info-title" v-if="result.title">{{ result.title }}</span>
                            <span class="info-title" v-if="result.name">{{ result.name }}</span>
                            <span class="info-time">{{ result.releaseTime }}</span>
                            <span class="info-content" v-if="result.brand">{{ result.brand }} / {{ result.model}}</span>
                            <span  class="info-content" v-if="result.introduction">{{ result.introduction }}</span>
                            <div class="info-button">了解详情&nbsp;></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {searchContent} from '@/common/api'
import {ElMessage,ElLoading} from "element-plus";
import {findItemRecursive} from "@/common/urtils";
import {useStore} from "vuex";
import router from "@/route";
export default {
    name: "searchVue",
    data() {
        return {
            store: useStore(),
            searchValue: "",
            searchFilter: 0,
            radioList: [
                { value: 0, label: "全部"},
                { value: 6, label: "解决方案"},
                { value: 3, label: "产品中心"},
                { value: 5, label: "成功方案"},
                { value: 2, label: "企业动态"},
            ],
            searchResultList: []
        }
    },
    methods: {
        handleClick(item) {
            let data = findItemRecursive(this.store.state.menuList, item.menuId);
            let parentId = data[0].id;
            let activeIndex = this.store.state.menuList.findIndex(e=>e.id === parentId)
            router.push({
                path: `/cvi/home/article/view`,
                query: {
                    newId: item.id,
                    parentId: parentId,
                    activeIndex: activeIndex,
                    activeTag: 0,
                    contentType: item.contentType
                }
            })
        },
        filterImage(src) {
            return  src !== "" ? src.split(',')[0] : ""
        },
        handleSearch() {
            let params = {}
            if(this.searchValue === "") return ElMessage.warning("请输入需要搜索的关键信息")
            if(this.searchFilter === 0) {
                params['keyword'] = this.searchValue
            }else {
                params['contentType'] = this.searchFilter
                params['keyword'] = this.searchValue
            }
            const loading = ElLoading.service({
                text: "正在检索中，请稍后...",
                background: "rgba(0, 0, 0, .7)",
                customClass: "custom-loading",
                lock: true,
            })
            searchContent(params).then(res=> {
                if(res.success) {
                    setTimeout(()=> {
                        this.searchResultList = res.data;
                        loading.close();
                    },150)
                }else {
                    loading.close();
                    setTimeout(()=>{
                        ElMessage.error(res.msg)
                    },150)
                }
            }).catch(()=>{
                loading.close();
                setTimeout(()=>{
                    ElMessage.error("检索失败，请重试~")
                },150)
            })
        },
        changeFilterValue() {
            this.handleSearch()
        }
    }
}
</script>

<style scoped lang="less">
    @keyframes click {
        to {
            opacity: 0.6;
        }
        from {
            opacity: 1;
        }
    }
    .search-page {
        width: 1200px;
        height: auto;
        margin: 65px auto;
        .search-page__header {
            padding-top: 60px;
            padding-bottom: 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .label {
                font-size: 34px;
                font-weight: bold;
                color: #FF6900;
                line-height: 1;
            }
            ::v-deep .el-input {
                margin-top: 60px;
                width: 781px;
                .el-input__wrapper {
                    height: 45px;
                    box-shadow: none;
                    border: 1px solid #808080;
                    border-radius: 0;
                    border-right: none;
                    .el-input__inner {
                        font-size: 16px;
                        color: #666666;
                    }
                }
                .el-input-group__append {
                    cursor: pointer;
                    height: 47px;
                    border: 1px solid #808080;
                    box-shadow: none;
                    border-left: none;
                    border-radius: 0;
                    background-color: transparent;
                    .button-text {
                        font-size: 16px;
                        color: #666666;
                    }
                }
            }
        }
        .search-page__main {
            display: flex;
            align-items: flex-start;
            .page-filter {
                width: 160px;
                height: 300px;
                margin-right: 60px;
                display: flex;
                flex-direction: column;
                .page-filter__tip {
                    font-size: 24px;
                    line-height: 1;
                    color: #808080;
                    padding-bottom: 30px;
                    margin-bottom: 30px;
                    border-bottom: 1px solid #DFDFDF;
                }
                ::v-deep .el-radio-group {
                    flex-direction: column;
                    align-items: flex-start;
                    .el-radio {
                        display: flex;
                        align-items: center;
                        height: 18px;
                        margin-bottom: 30px;
                        .el-radio__inner {
                            width: 16px;
                            height: 16px;
                            border-color: #808080;
                            &::after {
                                width: 8px;
                                height: 8px;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                            }
                        }
                        .el-radio__label {
                            font-size: 16px;
                            color: #666666;
                        }
                        .el-radio__input{
                            &.is-checked {
                                .el-radio__inner {
                                    background-color: #FFFFFF !important;
                                    &::after {
                                        background-color: #FF6900 !important;
                                    }
                                }
                            }
                        }
                    }
                }

            }
            .page-content {
                flex: 1;
                .page-content__number {
                    font-size: 16px;
                    color: #808080;
                    span {
                        color: #FF6900;
                        margin-right: 4px;
                    }
                }
                .page-content__view {
                    .item {
                        padding: 60px 0;
                        border-bottom: 1px solid #DFDFDF;
                        display: flex;
                        &:nth-last-of-type(1) {
                            border-bottom: none;
                        }
                        .item-image {
                            flex-shrink: 0;
                            width: 182px;
                            height: 122px;
                        }
                        .item-info {
                            flex: 1;
                            margin-left: 20px;
                            display: flex;
                            flex-direction: column;
                            .info-title {
                                font-size: 18px;
                                line-height: 1;
                                color: #184079;
                                font-weight: bold;
                            }
                            .info-time {
                                margin: 10px 0;
                                line-height: 1;
                                font-size: 14px;
                                color: #666666;
                            }
                            .info-content {
                                line-height: 1;
                                font-size: 16px;
                                color: #808080;
                                word-break: break-all;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                // 禁用自动添加浏览器前缀
                                /* autoprefixer: off */
                                display: -webkit-box;
                                -webkit-line-clamp: 1;// 代表文本超长最多显示2行，可自行调整最多显示的行数
                                -webkit-box-orient: vertical;
                            }
                            .info-button {
                                margin-top: auto;
                                align-self: flex-end;
                                width: max-content;
                                color: #FFFFFF;
                                background-color: #FF6900;
                                font-size: 14px;
                                padding: 6px 10px;
                                cursor: pointer;
                                &:hover,&:active {
                                    animation: click .1s linear forwards;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
